import ensureHtml from '../../../../services/ensureHtml';

export const name = 'ensureHtml';
export const defaultProp = true;
export const onParse = ensureHtml;
